var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4680_18027)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4680_18027",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 89,
    height: 89
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.002 -0.000976562H0.00195312V87.999H88.002V-0.000976562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4680_18027)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.673938
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0059 5.45703C64.9232 5.45703 81.9064 22.4402 81.9064 43.3575C81.9064 64.2748 64.9232 81.258 44.0059 81.258C23.0887 81.258 6.10547 64.2748 6.10547 43.3575C6.10547 22.4402 23.0887 5.45703 44.0059 5.45703Z",
    fill: "#C7F1E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0059 5.45703C64.9232 5.45703 81.9064 22.4402 81.9064 43.3575C81.9064 64.2748 64.9232 81.258 44.0059 81.258C23.0887 81.258 6.10547 64.2748 6.10547 43.3575C6.10547 22.4402 23.0887 5.45703 44.0059 5.45703Z",
    stroke: "white",
    strokeWidth: 0.642381
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.0039 13.1255C60.7937 13.1255 74.4258 26.7575 74.4258 43.5474C74.4258 60.3372 60.7937 73.9692 44.0039 73.9692C27.2141 73.9692 13.582 60.3372 13.582 43.5474C13.582 26.7575 27.2141 13.1255 44.0039 13.1255Z",
    fill: "#2CDA94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8242 44.7729L38.6758 53.4526L56.5508 34.9761",
    stroke: "white",
    strokeWidth: 5.15625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4680_18027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.6e4f491c69f4c9f7b538c01a15a751c5.svg";
export { ForwardRef as ReactComponent };